import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pg_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("pg_admin_token");
        setAdmin(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("pg_admin_token", data.token);
    setAdmin({ username: data.username, role: data.role });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("pg_admin_token");
    setAdmin(null);
  };

  // Memoise the context value so consumers don't re-render on every parent
  // render — only when admin/checking actually change. login/logout are
  // stable closures by reference (they only mutate state via setters).
  const value = useMemo(
    () => ({ admin, checking, login, logout }),
    [admin, checking],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
